/** @format */

import { render } from "solid-js/web";
import { BeforeLeaveEventArgs, HashRouter, Route, Router, useBeforeLeave, useNavigate, useSearchParams } from "@solidjs/router";
// import App from "./views/app";
import "./index.scss";
import "./index.mobile.scss";
import { Menu, registry } from "neko-ui";

import { createSignal, For, lazy, Show } from "solid-js";
import { convertToTwoDimensionalArray } from "./utils/utils.array";
import { setUserInfo, userInfo } from "./global.store.ts";
import { clearAllLocalStorage, constData, getUserMenu } from "./utils/storage.ts";
import { globalMqtt } from "./utils/mqttClient.ts";
import { zsRoot } from "./zs_view/zsRoot.tsx";
import { sm4 } from "sm-crypto-v2";

registry(Menu);
export const RouterComponent: any = {
  "/": lazy(() => import("./views/index/inx")),
  "/ode": lazy(() => import("./views/order/order")),
  "/odt/:id": lazy(() => import("./views/order/detail")),
  "/psode": lazy(() => import("./views/order/psOde")),
  "/user": lazy(() => import("./views/user/user")),
  "/udt/:id": lazy(() => import("./views/user/detail")),
  "/updstas/:id": lazy(() => import("./views/index/statsForm.tsx")),
  "/fin-recs": lazy(() => import("./views/finance/finance")),
  "/fin-uu": lazy(() => import("./views/finance/userUarnings.tsx")),
  "/fin-uudt": lazy(() => import("./views/finance/userUarningsDetail.tsx")),
  "/afsOde": lazy(() => import("./views/order/afsOrder")),
  "/login": lazy(() => import("./views/login/login")),
  "/adcm/ct-all": lazy(() => import("./views/category/all.tsx")),

  "/adcm/ls": lazy(() => import("./views/comd/list.tsx")),
  "/adcm/dt": lazy(() => import("./views/comd/detail.tsx")),

  "/ode/all-ps": lazy(() => import("./views/order/allPsOde.tsx")),

  "/procuement": lazy(() => import("./views/procuement/procuement.tsx")),
  "/procuementdt": lazy(() => import("./views/procuement/procuementdt.tsx")),

  // aTxt 相关路由
  "/atxt": lazy(() => import("./views/sys/aTxt.tsx")),
  "/atxtdt": lazy(() => import("./views/sys/aTxtDt.tsx")),

  // 后厨
  "/adode/screen-food": lazy(() => import("./views/order/kitchen.tsx")),

  // 招商银行

  "/zs": lazy(() => import("./zs_view/zs.tsx")),
  "/zs/hj": lazy(() => import("./zs_view/hj/zsHj.tsx")),
  "/zs/hj/inx": lazy(() => import("./zs_view/hj/hjInx.tsx")),
};

/**
 * 前端app网页应用
 */
export const ykmbjApp: any = [
  {
    path: "/code",
    component: lazy(() => import("./ykmbjv2/code.tsx")),
  },
];

try {
  // const routes: any[] = [];
  const Layout = (props: any) => {
    let navigate = useNavigate();

    function menuChange(e: any) {}

    const [menuState, setMenuState] = createSignal(0);

    useBeforeLeave((e: BeforeLeaveEventArgs) => {
      //"beforeLeave", e);
      // if (form.isDirty && !e.defaultPrevented) {
      //   // preventDefault to block immediately and prompt user async
      //   e.preventDefault();
      //   setTimeout(() => {
      //     if (window.confirm("Discard unsaved changes - are you sure?")) {
      //       // user wants to proceed anyway so retry with force=true
      //       e.retry(true);
      //     }
      //   }, 100);
      // }
    });

    return (
      <>
        <div class="root_container app_container">
          <Show when={menuState() === 1}>
            <div class="app_menu_mask glass_effect" onClick={() => setMenuState(0)}></div>
          </Show>

          <div classList={{ app_menu: true, app_menu_open: menuState() === 1 }}>
            <n-menu
              class="aaaaaaaa"
              items={menuViewData}
              onChange={(e: any) => {
                setMenuState(0);
                navigate(e.detail[0], { replace: true });
              }}
            />
          </div>

          <div class="app_content">
            <div class="app_header p_card row_sb_gap">
              <div
                onClick={() => {
                  setMenuState(menuState() === 1 ? 0 : 1);
                }}
              >
                开
              </div>

              <div
                onClick={() => {
                  clearAllLocalStorage();
                  // window.location.reload();
                  window.location.href = "/";
                }}
              >
                {userInfo.name}
              </div>
            </div>
            <div style="height:50px;"></div>

            <div>{props.children}</div>
          </div>
        </div>
      </>
    );
  };

  const routerData: any[] = getUserMenu();
  let menuViewData: any[] = [];
  let routers: any[] = [];
  //"routerData", routerData);

  for (let inx = 0; inx < routerData.length; inx++) {
    const element = routerData[inx];
    element.value = element.path || element.label;
    if (element.path) {
      //"----------------------------------", element.path, routers.length);

      routers.push({
        path: element.path,
        component: RouterComponent[element.path],
      });
      //"----------------------------------", element.path, routers.length);
    }
    if (element.view !== 0) {
      menuViewData.push(element);
    }
  }
  //"??????????????", routers.length);

  menuViewData = convertToTwoDimensionalArray(menuViewData);

  // 如果有启动参数
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("p");
  if (token) {
    setUserInfo({
      ...userInfo,
      roles: [10],
      // @ts-ignore
      ...JSON.parse(sm4.decrypt(token, constData.sm4Def)),
    });
    routers = ykmbjApp;
    console.log("token", routers, userInfo);
  }

  console.log("???", token);

  if (userInfo.id) {
    // @ts-ignore
    const { FARM_APP_NAME, FARM_MQTT_URL } = import.meta.env;
    globalMqtt.initMqtt({
      options: {
        clientId: FARM_APP_NAME + "_" + userInfo.account + "_" + Math.floor(Math.random() * 20) + 1,
        host: FARM_MQTT_URL, // 你的 EMQX 服务器IP（本地部署填 localhost）
        // port: 8084, // WebSocket 固定端口，不可改
        username: "admin", // EMQX 账号（默认 admin）
        password: "Hong159874@.@", // EMQX 密码（默认 public，生产环境务必修改）
        keepalive: 60, // 心跳间隔（秒）
        connectTimeout: 30000, // 连接超时（毫秒）
        reconnectPeriod: 5000, // 断线自动重连间隔（毫秒），5秒一次
        // clean: true,
      },

      callback: () => {
        //"mqtt连接成功");
        // 订阅主题
        globalMqtt.publish("test", "你好！！！！！！！！！！！！！！");
      },
    });
    //"=-=-=-", userInfo);
    if (userInfo.roles.includes(9)) {
      //"?=========", routers);
      // console.log("如果是配送员",routers);
      
      // // 如果是配送员
      // for (let i = 0; i < routers.length; i++) {
      //   const element = routers[i];
      //   // window.location.href = "/psode";
      //   // if (element.path === "/psode") {
      //   //   // element.meta.hidden = false;
      //   //   element.path = "/";
      //   // }
      // }
    } else if (userInfo.roles.includes(10) && userInfo.roles.length == 1) {
      // 如果是招商银行
      for (let i = 0; i < routers.length; i++) {
        const element = routers[i];
        if (element.path === "/zs") {
          // element.meta.hidden = false;
          element.path = "/";
        }
      }
    }
    // 校验用户角色
  }
  render(() => {
    return (
      <>
        <Show when={userInfo.id}>
          <Router root={userInfo.roles.includes(10) ? zsRoot : Layout}>{routers}</Router>
        </Show>
        <Show when={!userInfo.id}>
          <Router>
            <Route path="/" component={RouterComponent["/login"]} />
          </Router>
        </Show>
      </>
    );
  }, document.getElementById("root")!);
} catch (error) {
  //"有报错", error);
}
